import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";
import PropTypes from 'prop-types';
import React from 'react';
import { formatNumber } from 'humanize-plus';
import { isNull, isNumber } from 'lodash';
function getWholeNumber() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var stringValue = isNumber(value) ? value.toString() : value;
  return _parseInt(stringValue.split('.')[0], 10);
}
export function dollarAmount() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var convertCents = arguments.length > 1 ? arguments[1] : undefined;
  if (isNull(value)) {
    return '';
  }
  if (value === 'Required') {
    return 'Required';
  }
  if (convertCents) {
    var floatNum = (_parseFloat(value) / 100).toFixed(2);
    return Number.isNaN(floatNum) ? '' : "$".concat(formatNumber(floatNum, 2));
  }
  var number = getWholeNumber(value);
  return Number.isNaN(number) ? '' : "$".concat(formatNumber(number));
}
var DollarAmount = function DollarAmount(_ref) {
  var value = _ref.value,
    convertCents = _ref.convertCents,
    className = _ref.className,
    dataLabel = _ref.dataLabel;
  return /*#__PURE__*/React.createElement("span", {
    className: className,
    "data-test-element": dataLabel
  }, dollarAmount(value, convertCents));
};
DollarAmount.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  convertCents: PropTypes.bool,
  className: PropTypes.string,
  dataLabel: PropTypes.string
};
DollarAmount.defaultProps = {
  value: '',
  convertCents: false,
  className: 'dollar-amount',
  dataLabel: 'monthly-income-display'
};
export default DollarAmount;
//# sourceMappingURL=DollarAmount.js.map